module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Darren Shan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Darren Shan")]), _vm._v(" is the bestselling author of the young adult series Cirque Du Freak, The Demonata, and the Saga of Larten Crepsley series, as well as the stand-alone book "), _c('I', [_vm._v("The Thin Executioner")]), _vm._v(". His books have sold over 25 million copies worldwide. Shan divides his time between his homes in Ireland and London.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Bhu9nZ/images/9780316126335.jpg?1734367809883",
      "alt": "This image is the cover for the book Hell's Heroes, The Demonata"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hell's Heroes, The Demonata\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The battle for the world comes to its terrifying climax in the final novel of the ")]), _c('i', [_c('b', [_vm._v("New York Times")])]), _c('b', [_vm._v(" bestselling author's YA supernatural horror series.")])]), _c('p', [_vm._v("Beranabus and Dervish are gone. Bec has formed an unholy alliance with Lord Loss. Kernel is blind, held on Earth against his will. Grubbs is mad with grief and spinning out of control. The demons are crossing. The Disciples are falling. The Shadow is waiting. Welcome to the end.")]), _c('p', [_vm._v("The tenth and final novel in the chilling Demonata series by Darren Shan, author of the Cirque Du Freak series, will bring the epic struggle against demon kind to a truly cataclysmic conclusion.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown Young Readers\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0